import {noTokenApiClient} from "../utils/loginApiClient";
import {dataFetchHelper} from "./baseDataFetch";

const [
  getIsDeclineReferralTokenValid,
  useGetIsDeclineReferralTokenValid,
] = dataFetchHelper(([token]) => {
  const sanitizedToken = encodeURIComponent(token);
  return noTokenApiClient.get(
    `/v1/referrals/validate-decline-token?token=${sanitizedToken}`,
    {
      headers: {},
    }
  );
});

const declineReferral = (referralDecline) => {
  return noTokenApiClient.post(`/v1/referrals/decline`, referralDecline, {
    headers: {},
  });
};

export { declineReferral, getIsDeclineReferralTokenValid, useGetIsDeclineReferralTokenValid };
